export const CONDITIONS_OF_USE_REGION_BUTTON =
  'CONDITIONS_OF_USE_REGION_BUTTON';
export const LANGUAGE_DROPDOWN_CLICK = 'LANGUAGE_DROPDOWN_CLICK';
export const DROPDOWN_CLICK = 'DROPDOWN_CLICK';
export const SETTINGS_BUTTON_CLICK = 'SETTINGS_BUTTON_CLICK';
export const PRIVACY_BUTTON_REGION = 'PRIVACY_BUTTON_REGION';
export const CONDITIONS_OF_USE_BUTTON = 'CONDITIONS_OF_USE_BUTTON';
export const PRIVACY_NOTICE_BUTTON = 'PRIVACY_NOTICE_BUTTON';
export const SIDE_NAV_MENU_BUTTON = 'SIDE_NAV_MENU_BUTTON';
export const HEADER_FAQ_BUTTON = 'HEADER_FAQ_BUTTON';
export const HEADER_GET_STARTED_BUTTON = 'HEADER_GET_STARTED_BUTTON';
export const MY_PROFILE_CLICK = 'MY_PROFILE_CLICK';
export const MANAGE_USERS_CLICK = 'MANAGE_USERS_CLICK';
export const HEADER_SIGN_IN_BUTTON = 'HEADER_SIGN_IN_BUTTON';
export const SIGN_OUT_BUTTON = 'SIGN_OUT_BUTTON';
export const SIGN_UP_BUTTON = 'SIGN_UP_BUTTON';
export const LP_SELECT_DROPDOWN_ITEM_CLICK = 'LP_SELECT_DROPDOWN_ITEM_CLICK';
export const LOCALE_DROPDOWN_ITEM_CLICK = 'LOCALE_DROPDOWN_ITEM_CLICK';
